import React from 'react';
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TablePagination,
  Pagination,
  Stack,
  useMediaQuery,
} from '@mui/material';
import AnnouncementIcon from '@mui/icons-material/Campaign';
import LinkIcon from '@mui/icons-material/Link';
import ScheduleIcon from '@mui/icons-material/Schedule';
import {
  BackdropLoading,
  BookButton,
  CardComponent,
} from '../../components';

import { WHITE_COLOR, GREY_COLOR } from '../../styles/constants';
import { TableHeadComponent, TableRows } from '../../components';
import AnnouncementModal from '../modals/announcement';
import { useTheme } from '@mui/material/styles';
import { useAnnouncement } from './hooks/announcement.hook';
import { useStyles } from './announcement.style';
import AddIcon from '@mui/icons-material/Add';

const AnnouncementTable = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {
    AnnouncementData,
    action,
    AnnouncementCount,
    open,
    setOpen,
    singleAnnouncement,
    tableCells,
    actionsIcons,
    limit,
    page,
    isLoading,
    handleGetAnnouncementData,
    handleAdd,
    handleActionClick,
    handleChangePage,
    calculatePagesCount,
    handleChangeRowsPerPage,
  } = useAnnouncement();

  const dataIcons = [
    { id: 'title', title: 'Title', gridTitleSize: 5, gridSize: 6 },
    {
      id: 'description',
      title: 'Description',
      gridTitleSize: 5,
      gridSize: 6,
      icon: (
        <AnnouncementIcon
          sx={{
            fontSize: '19px',
            marginLeft: '2px',
          }}
        />
      ),
    },
    {
      id: 'link',
      title: 'Link',
      gridTitleSize: 5,
      gridSize: 7,
      icon: (
        <LinkIcon
          sx={{
            fontSize: '19px',
            marginLeft: '2px',
          }}
        />
      ),
    },
    {
      id: 'scheduledAt',
      title: 'Scheduled At',
      gridTitleSize: 5,
      gridSize: 7,
      icon: (
        <ScheduleIcon
          sx={{
            fontSize: '19px',
            marginLeft: '2px',
          }}
        />
      ),
    },
    {
      id: 'url',
      title: 'URL',
      gridTitleSize: 5,
      gridSize: 7,
      icon: (
        <LinkIcon
          sx={{
            fontSize: '19px',
            marginLeft: '2px',
          }}
        />
      ),
    },
  ];

  return (
    <Box component='div' sx={isMobile && { paddingBottom: 10 }}>
      {open && (
        <AnnouncementModal
          tableCells={tableCells}
          open={open}
          setOpen={setOpen}
          singleAnnouncement={singleAnnouncement}
          action={action}
          handleGetAnnouncementData={handleGetAnnouncementData}
        />
      )}
      <BackdropLoading open={isLoading} />
      <Box
        component='div'
        sx={{
          width: '100%',
          position: isMobile && 'sticky',
          top: isMobile && '7rem',
          zIndex: isMobile && 1000,
          background: 'white',
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={10} lg={10}>
            {/* Empty space for layout */}
          </Grid>
          <Grid item xs={12} sm={12} md={2} lg={2}>
            <BookButton
              onSubmit={handleAdd}
              title='Add Announcement'
              type='primary'
              variant='contained'
              icon={<AddIcon />}
            />
          </Grid>
        </Grid>
      </Box>
      {isMobile ? (
        <>
          {AnnouncementData &&
            Object.keys(AnnouncementData).length > 0 &&
            AnnouncementData?.map(row => (
              <CardComponent
                key={'AnnouncementData' + row.id}
                sx={{
                  background: GREY_COLOR.GHOSTWHITE,
                  width: '97%',
                  margin: '20px 5px 5px 5px',
                }}
                classBorder={classes.statusCompleted}
                titleStyle={classes.titleStyle}
                uniqueKey='-AnnouncementCrud'
                rows={row}
                dataIcons={dataIcons}
                tableCells={tableCells}
                actionsIcons={actionsIcons}
                handleActionClick={handleActionClick}
              />
            ))}
          <Stack className={classes.paginationStyle} spacing={2}>
            <Pagination
              count={calculatePagesCount(limit, AnnouncementCount)}
              page={page + 1}
              onChange={(event, newPage) => handleChangePage(true, newPage)}
              color='primary'
            />
          </Stack>
        </>
      ) : (
        <>
          <TableContainer
            sx={{
              width: '100%',
              background: WHITE_COLOR,
            }}
          >
            <Table sx={{ minWidth: '100%' }} aria-label='simple table'>
              <TableHeadComponent tableCells={tableCells} />
              <TableBody>
                <TableRows
                  uniqueKey='-AnnouncementCrud'
                  tableCells={tableCells}
                  rows={AnnouncementData}
                  actionsIcons={actionsIcons}
                  handleActionClick={handleActionClick}
                />
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component='div'
            count={AnnouncementCount}
            page={page}
            onPageChange={(event, newPage) => handleChangePage(false, newPage)}
            rowsPerPage={limit}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[25, 50, 100, 250, 500, 750, 1000]}
          />
        </>
      )}
    </Box>
  );
};
export default AnnouncementTable;
